import * as KatalMetrics from '@amzn/katal-metrics';
import initialMetricsPublisher from './metrics';

const ServiceMetric = 'Service';

export const routerMetricsPublisher = initialMetricsPublisher.newChildPublisher(
  {
    cloudWatchDimensions: [
      new KatalMetrics.Metric.String(ServiceMetric, 'LeelaRouter'),
    ],
    methodName: 'Router',
  }
);

export const applicationMetricsPublisher =
  initialMetricsPublisher.newChildPublisher({
    cloudWatchDimensions: [
      new KatalMetrics.Metric.String(ServiceMetric, 'LeelaUI'),
    ],
    methodName: 'Application',
  });

export const apiMetricsPublisher = initialMetricsPublisher.newChildPublisher({
  cloudWatchDimensions: [
    new KatalMetrics.Metric.String(ServiceMetric, 'LeelaApi'),
  ],
  methodName: 'Api',
});

export const benderMetricsPublisher = initialMetricsPublisher.newChildPublisher(
  {
    cloudWatchDimensions: [
      new KatalMetrics.Metric.String(ServiceMetric, 'Bender'),
    ],
    methodName: 'Dependency',
  }
);
